var map = {
	"./#03CEA4/headingEle.svg": "fd67",
	"./#3777FF/headingEle.svg": "ca3b",
	"./#EE964B/headingEle.svg": "59a5",
	"./#F754A2/headingEle.svg": "d6cb",
	"./#FF495C/headingEle.svg": "2fb10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3c33";